import Blue from "~/core";

new Blue({
	name: 'TableDetail',
	selector: ".table-detail",
	setup(tableDetail) {
        const trigger = tableDetail.querySelector('.table-detail__toggle');
        let contents = [...tableDetail.querySelectorAll('.table-row--expandable')];
        let allTableRows = [...tableDetail.querySelectorAll('.table-row')];
        let activeTableRows = [...tableDetail.querySelectorAll('.table-row:not(.table-row--expandable)')];

        const toggle = () => {
            contents.forEach(content => {
                content.__start = content.offsetHeight;
            })
            tableDetail.classList.toggle('is-active')
            contents.forEach(content => {
                content.__end = content.offsetHeight;
            })

            contents.forEach(content => {
                content.animate([
                    {height: `${content.__start}px`},
                    {height: `${content.__end}px`}
                ], {
                    duration: 300,
                    easing: 'ease'
                });
            })
            setBackgrounds();
        }

        const setBackgrounds = () => {
            if (tableDetail.classList.contains('is-active')) {
                stripeRows(allTableRows);
            }
            else {
                stripeRows(activeTableRows);
            }
        };
        
        function stripeRows(elements) { 
            elements.forEach(function (element, index) {
                if (index % 2 == 0) {
                    element.querySelectorAll('.table-cell').forEach(el => el.style.backgroundColor = '#fff');
                } else {
                    element.querySelectorAll('.table-cell').forEach(el => el.style.backgroundColor = '#dee2e6');
                }
            });
        }

        //init
        this.$addEvents(trigger, 'click.stop.prevent space.stop.prevent', toggle);
        setBackgrounds();

	}
});